import { render, staticRenderFns } from "./FacadeRenovation.vue?vue&type=template&id=4045f30b&scoped=true&"
import script from "./FacadeRenovation.vue?vue&type=script&lang=js&"
export * from "./FacadeRenovation.vue?vue&type=script&lang=js&"
import style0 from "./FacadeRenovation.vue?vue&type=style&index=0&id=4045f30b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4045f30b",
  null
  
)

export default component.exports